import { render, staticRenderFns } from "./PersonProfileAliasIdOverviewRow.vue?vue&type=template&id=6fd399b2&scoped=true&"
import script from "./PersonProfileAliasIdOverviewRow.vue?vue&type=script&lang=js&"
export * from "./PersonProfileAliasIdOverviewRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd399b2",
  null
  
)

export default component.exports